import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import CircleProgressBar from 'ui/base/CircleProgressBar';

import s from './Spinner.module.scss';

const cx = cn.bind(s);

const Spinner = ({
  theme = 'mint', className, ...attrs
}) => (
  <CircleProgressBar theme={theme} progress={40} animationDelay={200} className={cx(className, 'spinner')} hasProgress={false} {...attrs} />
);

Spinner.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default Spinner;
